export default __webpack_public_path__ + "static/media/MuseoSans_500-webfont.9421378a.svg";